import React, { useEffect } from "react";
import { Box, Button, Typography, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ContentUsBgImage from "@assets/ContentUsBgImage.png";
const SignUpContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  // width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  padding: "16px",
  [theme.breakpoints.down("sm")]: {
    padding: "8px",
    alignItems: "flex-start",
    paddingTop: "20px",
  },
}));

const ContactSection = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px 0px",
  position: "relative",
  width: "100%",
  height: "100%",
  gap: 16,
  maxWidth: "900px",
  margin: "0 auto",
  [theme.breakpoints.down("lg")]: {
    gap: 12,
    flexDirection: "column",
    padding: "12px",
    maxWidth: "900px",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "16px 8px",
    gap: 10,
    maxWidth: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "12px 6px",
    gap: 8,
  },
}));

const BackgroundOverlay = styled(Box)({
  position: "absolute",
  height: "100%",
  left: 0,
  top: 0,
  width: "100%",
  backgroundImage: `
    radial-gradient(ellipse 42.02px 68.593px at 298.8px 124.35px, rgba(220,253,255,0.4) 0%, rgba(255,255,255,0) 100%),
    radial-gradient(ellipse 77.28px 6.0674px at 1471.2px 363.44px, rgba(220,253,255,0.4) 0%, rgba(255,255,255,0) 100%),
    radial-gradient(ellipse 1.62px 57.671px at 682.2px 879.48px, rgba(197,255,225,0.4) 0%, rgba(255,255,255,0) 100%)
  `,
});
const LeftPanel = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "620px",
  height: "520px",
  backgroundImage: `url(${ContentUsBgImage})`,
  borderRadius: "32px",
  border: "1px solid #ffffff",
  overflow: "hidden",
  marginRight: "-80px",
  flexShrink: 0,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  [theme.breakpoints.down("lg")]: {
    width: "480px",
    height: "400px",
    marginRight: "-20px",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    maxWidth: "500px",
    height: "auto",
    minHeight: "240px",
    aspectRatio: "16 / 10",
    marginRight: 0,
    borderRadius: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
    minHeight: "240px",
    borderRadius: "16px",
  },
}));

const LeftPanelContent = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: "95.5px",
  top: "101px",
  width: "480px",
  color: "#ffffff",
  [theme.breakpoints.down("lg")]: {
    left: "32px",
    top: "48px",
    width: "380px",
  },
  [theme.breakpoints.down("md")]: {
    position: "relative",
    left: 0,
    top: 0,
    width: "100%",
    padding: "16px 12px 12px",
    textAlign: "center",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "16px 12px 12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const MainTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Rethink Sans, sans-serif",
  fontWeight: 600,
  fontSize: "64px",
  lineHeight: "1.1",
  marginBottom: "40px",
  color: "#ffffff",
  [theme.breakpoints.down("lg")]: {
    fontSize: "42px",
    marginBottom: "24px",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "36px",
    marginBottom: "12px",
    lineHeight: "1.2",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "28px",
    marginBottom: "12px",
    paddingTop: "48px",
    textAlign: "center",
  },
}));

const SubTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Rethink Sans, sans-serif",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "1.5",
  color: "#ffffff",
  width: "422px",
  textAlign: "center",
  whiteSpace: "normal",
  overflowWrap: "normal",
  wordBreak: "normal",
  hyphens: "none",
  [theme.breakpoints.down("lg")]: {
    width: "360px",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    fontSize: "16px",
    lineHeight: "1.45",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    lineHeight: "1.4",
    maxWidth: 300,
    margin: "0 auto",
    textAlign: "center",
    whiteSpace: "normal",
    overflowWrap: "normal",
    wordBreak: "normal",
    hyphens: "none",
  },
}));

const RightPanel = styled(Box)(({ theme }) => ({
  backgroundColor: "#f4feff",
  border: "1px solid #05495a",
  borderRadius: "16px",
  padding: "32px 28px 32px 32px",
  width: "480px",
  position: "relative",
  flexShrink: 0,
  minHeight: 500,
  [theme.breakpoints.down("lg")]: {
    width: "420px",
    padding: "28px 24px 28px 28px",
    minHeight: 540,
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    maxWidth: "480px",
    padding: "24px 18px 24px 24px",
    minHeight: 520,
  },
  [theme.breakpoints.down("sm")]: {
    padding: "20px 14px 20px 20px",
    borderRadius: "12px",
    margin: "0 6px",
    maxWidth: "90%",
    minHeight: 500,
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  height: "100%",
  alignItems: "flex-start",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
  },
}));

const FormContainer = styled(Box)(({ theme }) => ({
  width: "489px",
  height: "416px",
  position: "relative",
  top: "67px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    top: 0,
    height: "auto",
  },
}));

const SuccessContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "35px",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  width: "100%",
  height: "475px",
  [theme.breakpoints.down("sm")]: {
    gap: "24px",
    height: "auto",
  },
}));

const SuccessIcon = styled(Box)({
  width: "101px",
  height: "101px",
  backgroundColor: "#13a10e",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "center",
  marginBottom: "24px",
});

const SuccessTitle = styled(Typography)({
  fontFamily: "Rethink Sans, sans-serif",
  fontWeight: 700,
  fontSize: "28px",
  lineHeight: "35px",
  color: "#13a10e",
  textAlign: "center",
  width: "100%",
});

const SuccessMessage = styled(Typography)({
  fontFamily: "Rethink Sans, sans-serif",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "1.5",
  color: "#033843",
  textAlign: "center",
  width: "100%",
});

const SignInButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(90deg, #0a829d 0%, #35d7e4 100%)",
  border: "1px solid #ffffff",
  borderRadius: "60px",
  height: "60px",
  width: "253px",
  padding: "12px 24px",
  textTransform: "none",
  fontFamily: "Rethink Sans, sans-serif",
  fontWeight: 600,
  fontSize: "18px",
  lineHeight: "22px",
  color: "#ffffff",
  alignSelf: "center",
  boxShadow:
    "0px 4px 24px 0px rgba(10,130,157,0.2), 0px 4px 7.3px 0px rgba(133,233,255,0.4)",
  "&:hover": {
    background: "linear-gradient(90deg, #086e86 0%, #2bc9d6 100%)",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    maxWidth: 300,
  },
}));

const CenteredContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    gap: "16px",
  },
}));

const MessageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  alignItems: "center",
  justifyContent: "flex-start",
  height: "139px",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    height: "auto",
  },
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "24px",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "337px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    gap: "16px",
  },
}));

export default function ResetPasswordSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSignIn = () => {
    navigate("/login");
  };

  return (
    <SignUpContainer>
      <ContactSection>
        <BackgroundOverlay />

        <LeftPanel>
          <LeftPanelContent>
            <MainTitle>Welcome Back to UniComply</MainTitle>
            <SubTitle>
              Stay connected with clinics nationwide ensuring better healthcare
              compliance.
            </SubTitle>
          </LeftPanelContent>
        </LeftPanel>

        <RightPanel>
          <ContentContainer>
            <FormContainer>
              <SuccessContent>
                <CenteredContainer>
                  <SuccessIcon>
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SuccessIcon>

                  <SuccessTitle>Password Reset Successful</SuccessTitle>

                  <MessageContainer>
                    <SuccessMessage>
                      Your password has been updated successfully. You can login
                      using your new credentials now.
                    </SuccessMessage>
                  </MessageContainer>

                  <ButtonContainer>
                    <SignInButton onClick={handleSignIn}>SIGN IN</SignInButton>
                  </ButtonContainer>
                </CenteredContainer>
              </SuccessContent>
            </FormContainer>
          </ContentContainer>
        </RightPanel>
      </ContactSection>
    </SignUpContainer>
  );
}
